module.exports = __webpack_public_path__ + "img/ios-flame.254d0694.svg";